import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
	},
	{
		path: '',
		redirectTo: '',
		pathMatch: 'full'
	},
	{
		path: 'home',
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
	},
	{
		path: 'pricing',
		loadChildren: () => import('./pages/pricing/pricing.module').then(m => m.PricingPageModule)
	},
	{
		path: 'faq',
		loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqPageModule)
	},
	{
		path: 'terms',
		loadChildren: () => import('./pages/terms/terms.module').then(m => m.TermsPageModule)
	},
	{
		path: 'privacy',
		loadChildren: () => import('./pages/privacy/privacy.module').then(m => m.PrivacyPageModule)
	},
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact/contact.module').then( m => m.ContactPageModule)
  },
  {
    path: 'retail',
    loadChildren: () => import('./pages/retail/retail.module').then( m => m.RetailPageModule)
  },
  {
    path: 'resto',
    loadChildren: () => import('./pages/resto/resto.module').then( m => m.RestoPageModule)
  }
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
